import { css } from 'styled-components';

export const infoWrapper = css`
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 20px;

  @media only screen and (max-width: 794px) {
    grid-template-columns: 1fr;
  }
  @media only screen and (min-width: 900px) {
    grid-template-rows: 380px;
  }
`;

export const infoCard = css`
  min-width: 350px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 20%);
  padding: 20px;
  p {
    margin: 10px 0 0 0;
  }

  .infoCard_button {
    width: 100%;
    display: inline-block;
    margin: 8px 0 0 -8px;
  }

  @media only screen and (max-width: 639px) {
    text-align: center;
  }
`;

export const infoImage = css`
  max-width: 100%;
  align-self: stretch;
  object-fit: cover;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 20%);
  @media only screen and (max-width: 794px) {
    height: 280px;
    order: -1;
  }
`;

export const galleryCSS = css`
  background-color: var(--gallery);

  @media only screen and (max-width: 639px) {
    padding: 30px 0;
  }
`;